<template>
  <div class="cell-editor" :style="style" ref="editor">

    <v-select v-if="type === 'select-semana' || type === 'select-dia'" ref="select" dense solo flat hide-details
      item-text="nombre" item-value="id" class="cell-input" :items="options" v-model="localValue" open-on-focus
      :menu-props="{ eager: true }" @keydown.enter.stop.prevent @keyup.enter.stop.prevent
      @keydown.esc.stop.prevent="cancel" @blur="cancel">
      <template v-slot:item="{ item, on, attrs }">
        <v-list-item v-bind="attrs" v-on="on" @click="onItemClick(item)"
          @keydown.enter.stop.prevent="onItemClick(item)">
          <v-list-item-content>
            <v-list-item-title>{{ item.nombre }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-select>
    <!--     -->
    <TimeCellInput v-else-if="type === 'time'" ref="time" class="cell-input" v-model="localValue" @commit="commit"
      @cancel="cancel" @error="onHorarioError" />

    <v-text-field v-else-if="type === 'number'" ref="input" dense solo flat hide-details type="number"
      class="cell-input" v-model="localValue" @keydown.enter.stop.prevent="commit(true)"
      @keydown.esc.stop.prevent="cancel" @blur="commit(false)"/>

    <v-text-field v-else-if="type === 'text'" ref="input" dense solo flat hide-details class="cell-input"
      v-model="localValue" @keydown.enter.stop.prevent="commit(true)" @keydown.esc.stop.prevent="cancel" clearable
      @click:clear="clear" />


       <PersonaBuscador v-else-if="type === 'ac-docente'" v-model="localValue" label="Ingrese el DNI de la persona"
                                @personas:change="onItemClick"  @cancel="cancel" class="ma-2"></PersonaBuscador>
      <!-- @blur="commit(false)" -->
  </div>
</template>

<script>
import TimeCellInput from "./TimeCellInput.vue";
import PersonaBuscador from '../persona/PersonaBuscador.vue'

export default {
  components: { TimeCellInput,PersonaBuscador },

  props: {
    value: { required: true },
    type: { type: String, required: true },
    options: { type: Array, default: () => [] },
    rect: { type: Object, required: true },
  },

  data() {
    return {
      localValue: this.value,
      menuOpen: false,
      lastValue: null
    };
  },

  computed: {
    style() {
      return {
        position: "absolute",
        top: `${this.rect.top}px`,
        left: `${this.rect.left}px`,
        width: `${this.rect.width}px`,
        height: `${this.rect.height}px`,
        zIndex: 1000,
      };
    },
  },

  mounted() {
    this.$nextTick(() => {
      // v-select
      if (this.$refs.select) {
        this.$refs.select.focus();

        this.$nextTick(() => {
          this.$refs.select.activateMenu();
        });

        return;
      }

      // v-text-field
      if (this.$refs.input) {
        const el = this.$refs.input.$el.querySelector("input");
        if (el) {
          el.focus();
          el.select();
        }
        return;
      }
    });
  },
  methods: {
    onItemClick(item) {
      this.localValue = item;
      this.commit(true);
    },
    clear() {
      this.localValue = "";
      this.$emit("input", "");
      this.commit(false);
    },
    commit(configEnter) {

      this.$emit("commit", {
         value: this.localValue,
        configEnter: configEnter
      }
      );
    },
    cancel() {
      this.$emit("cancel");
    },
    onHorarioError(msg) {
      this.$toast.error(msg);
    },
  },
};
</script>

<style scoped>
.cell-editor {
  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  background: white;

  box-shadow: inset 0 0 0 2px #1976d2;

  /* espacio para que no tape el borde */
  padding: 2px;
}

::v-deep .cell-editor .cell-input {
  width: 100%;
  height: 100%;
}

::v-deep .cell-editor .v-input {
  margin: 0;
  height: 100%;
}

::v-deep .cell-editor .v-input__control {
  height: 100%;
}

::v-deep .cell-editor .v-input__slot {
  height: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;

  /* NO padding acá */
  padding: 0 !important;

  border-radius: 0 !important;
  background: transparent !important;
}

::v-deep .cell-editor .v-text-field__slot {
  height: 100%;
  display: flex;
  align-items: center;
}

/* padding real para el texto */
::v-deep .cell-editor input {
  height: 100% !important;
  margin: 0 !important;
  padding: 0 6px !important;
  line-height: 1.2 !important;
  background: transparent !important;
}

::v-deep .cell-editor .v-select__selections {
  align-items: center;
  margin: 0 !important;
  padding: 0 6px !important;
}
::v-deep .cell-editor .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot,
::v-deep .cell-editor .v-text-field.v-text-field--enclosed
  .v-text-field__details {
  padding: 0 1px !important;
}
</style>
